/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 2.5a3.125 3.125 0 110 6.25 3.125 3.125 0 010-6.25zm0-1.25A4.375 4.375 0 1010 10a4.375 4.375 0 000-8.75zm6.25 17.5H15v-3.125a3.125 3.125 0 00-3.125-3.125h-3.75A3.125 3.125 0 005 15.625v3.125H3.75v-3.125a4.375 4.375 0 014.375-4.375h3.75a4.375 4.375 0 014.375 4.375v3.125z"/>'
  }
})
